import classNames from "classnames";
import React, { useCallback, useMemo } from "react";
import { Text } from "../text";
import { NavSubMenuItem } from "../types";
import { CSS_CLASSES as NAV_MENU_CSS_CLASSES } from "./nav-menu-css-classes";

export interface VerticalMainNavMenuSubItemProps {
  subItem: NavSubMenuItem;
  onClick: (subItem: NavSubMenuItem) => void;
}

export const VerticalMainNavMenuSubItem = ({ subItem, onClick }: VerticalMainNavMenuSubItemProps) => {
  /**
   * The `subItem` `onClick` property is ignored as it is handled via `handleClick`
   */
  const {
    label,
    active,
    navMenuItemComponent,
    navMenuItemComponentProps,
    href,
    className,
    onClick: ignoreOnClick,
    ...restProps
  } = subItem;

  const handleClick = useCallback(() => {
    onClick(subItem);
  }, [onClick, subItem]);

  const labelClassName = useMemo(
    () =>
      classNames(
        NAV_MENU_CSS_CLASSES.VERTICAL_MAIN_NAV_MENU_SUB_ITEM_LABEL,
        {
          [NAV_MENU_CSS_CLASSES.VERTICAL_MAIN_NAV_MENU_SUB_ITEM_LABEL_ACTIVE]: active,
        },
        className
      ),
    [active, className]
  );

  const Component = useMemo(
    () => (navMenuItemComponent ? navMenuItemComponent : href ? "a" : "div"),
    [href, navMenuItemComponent]
  );

  return (
    <Component
      href={href}
      className={NAV_MENU_CSS_CLASSES.VERTICAL_MAIN_NAV_MENU_SUB_ITEM_ROOT}
      onClick={handleClick}
      {...navMenuItemComponentProps}
      {...restProps}
    >
      <Text color="currentcolor" className={labelClassName}>
        {label}
      </Text>
    </Component>
  );
};
